import DropZone, { DropZoneVariant } from '../../molecules/drop-zone/DropZone';
import { FileWithPath } from 'react-dropzone';
import { useCallback, useState } from 'react';
import { FilePreviewVariant } from '../../atoms/file-preview/FilePreview.tsx';
import { fileToBase64 } from '../../utils/files.ts';

export type ImageUploadFieldProps = {
  fileNameFieldId: string;
  fileFieldId: string;
  onValueChange: (value: { fileName: string; fileAsBase64: string }) => void;
};

export function ImageUploadField({
  fileNameFieldId,
  fileFieldId,
  onValueChange,
}: ImageUploadFieldProps) {
  const [file, setFile] = useState<FileWithPath | null>(null);
  const [fileAsBase64, setFileAsBase64] = useState<string | undefined>(undefined);

  const handleFileChange = useCallback(
    async (newFile: FileWithPath | null) => {
      setFile(newFile);

      if (!newFile) {
        setFile(null);
        setFileAsBase64(undefined);

        onValueChange({ fileName: '', fileAsBase64: '' });

        return;
      }

      const newFileAsBase64 = await fileToBase64(newFile);

      setFile(newFile);
      setFileAsBase64(newFileAsBase64);

      onValueChange({ fileName: newFile.name, fileAsBase64: newFileAsBase64 });
    },
    [onValueChange],
  );

  const handleRemoveFile = useCallback(() => {
    setFile(null);
    setFileAsBase64(undefined);

    onValueChange({ fileName: '', fileAsBase64: '' });
  }, [onValueChange]);

  return (
    <>
      <input id={fileNameFieldId} type="hidden" value={file?.name || ''} />
      <input id={fileFieldId} type="hidden" value={fileAsBase64 || ''} />

      <DropZone.Root
        value={file}
        onValueChange={handleFileChange}
        variant={DropZoneVariant.MEDIA}
        className="h-44 w-full"
      >
        {file === null ? (
          <DropZone.DropArea className="size-full bg-neutral-50" />
        ) : (
          <DropZone.FilePreview.Root
            variant={FilePreviewVariant.MEDIA}
            fileName={file.name}
            fileSrc={URL.createObjectURL(file)}
            onRemove={handleRemoveFile}
          >
            <DropZone.FilePreview.Image />

            <DropZone.FilePreview.Actions.Root className="absolute right-0 top-0 p-2">
              <DropZone.FilePreview.Actions.RemoveButton />
            </DropZone.FilePreview.Actions.Root>
          </DropZone.FilePreview.Root>
        )}
      </DropZone.Root>
    </>
  );
}
